import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./Toast.scss";
import { images } from "@/utils/constants";
import { Toast, ToastContainer } from "react-bootstrap";
import { setShowToast } from "@/utils/constants/redux/sets";
import store from "@/app/providers/redux/store";
export const ToastFmc = () => {
    const { show, message } = store.getState().main.session.toast;
    return (_jsx(ToastContainer, { className: "fmc-cart-toast p-3", children: _jsx(Toast, { onClose: () => setShowToast(false), show: show, delay: 3000, autohide: true, children: _jsxs(Toast.Header, { children: [_jsx("img", { src: images.LogoLoading1, className: "rounded me-2", width: "64px", alt: "" }), _jsx("strong", { className: "me-auto", children: message })] }) }) }));
};
